var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.16 10.02"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.002 5.04a.416.416 0 00.14.274l5.041 4.55a.621.621 0 00.389.152.646.646 0 00.406-.116.429.429 0 00.186-.318.409.409 0 00-.145-.33l-4.7-4.244L6.018.764a.409.409 0 00.146-.33.429.429 0 00-.186-.317A.646.646 0 005.571 0a.621.621 0 00-.388.152L.142 4.7a.4.4 0 00-.14.34z",
    fill: "currentColor"
  })));
}

export default SvgChevronLeft;